export const AI_ASSISTANT_API_BASE_URL = '/api/dashboard/ai-assistant'
